import styled from '@emotion/styled';
import {Slider as MuiSlider, SliderProps} from '@mui/material';

const CustomSlider = styled(MuiSlider)(({theme}) => ({
  // ".MuiSlider-colorInfo":{
  //   color:"yellow"
  // },
  // "MuiSlider-rail":{
  //   backgroundColor: "yellow"
  // }
  "& .MuiSlider-rail": {
    color: theme.palette.borderColor
  },
  "& .MuiSlider-mark	": {
    backgroundColor: "currentColor",
    color: theme.palette.text.secondary,
    display: "none"

  },

}));

function Slider(props: Omit<SliderProps, "size">) {


  return <CustomSlider  {...props} size="small"/>

}

export default Slider;
export {Slider}